import { ViewModel,View } from "binder"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { BooleanPropertyType, ContentPropertyType, TemplatePropertyType, TemplateSelectorPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import  { ContentView } from "./content-view"
import { getAsBoolean } from "src/uicomponents/components/utilities";


export class ContentComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'Content';
        this.addProperty("Content","data-b-comp-content",new ContentPropertyType(this),null,false);
        this.addProperty("ItemTemplateSelector","data-b-comp-templateselectorfunction",new TemplateSelectorPropertyType(this),"",false);
        this.addProperty("NeedTemplateSelector","",new BooleanPropertyType(this),true,false);
    }

    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    
    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new ContentElement(parent);
        return result;    
    }
        
}

export class ContentElement extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ContentView();
    }
    public getTypeId(): string {
        return "VM-DDC493B9-3A67-4476-A614-D442D27796F9"
    }
    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitContent(this,parameter);
    }
    public set Content(v: ViewModel) { this._Content = v; } public get Content(): ViewModel { return this._Content;} private _Content: ViewModel;
    public set TemplateSelector(v: ITemplateSelector) { this._TemplateSelector = v; } public get TemplateSelector(): ITemplateSelector { return this._TemplateSelector;} private _TemplateSelector: ITemplateSelector;
    public set ItemTemplateSelector(v: string) { this._ItemTemplateSelector = v; } public get ItemTemplateSelector(): string { return this._ItemTemplateSelector;} private _ItemTemplateSelector: string;
    public set NeedTemplateSelector(v: boolean) { this._NeedTemplateSelector = getAsBoolean(v); } public get NeedTemplateSelector(): boolean { return this._NeedTemplateSelector;} private _NeedTemplateSelector: boolean;
    
    
    override onDataContextSet(){
        super.onDataContextSet();
        this.TemplateSelector = this.DataContext._Builder_TemplateSelector__;
    }
}
